import Action from "./Action";

export default class LinkAction extends Action {
    perform(scope) {
        super.perform(scope);
        window.location.href = this.applyVariables(this.param, scope);
    }
}

Action.register("link", LinkAction);



// WEBPACK FOOTER //
// ./src/components/chart/actions/LinkAction.js